import { Box, Button, Card, CardMedia, Checkbox, Container, FormControlLabel, Paper, Stack, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { Article } from "../../types/Article";
import { queryArticles, queryFeaturedArticles } from "../../utils/queryArticles";
import { FeaturedArticleBox } from "./FeaturedArticleBox";
import { ArticleRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export const ArticleIndex = () => {
    const navigate = useNavigate();
  
    const [isPublished, setIsPublished] = useState<boolean>(true);
    const [articles, setArticles] = useState<Article[]>([]);
    const [featuredArticles, setFeaturedArticles] = useState<Article[]>([]);

    const handleCreateArticleOnClick = () => {
        navigate(`/admin/articles/create`);
    };

    const handleArticleOnClick = (articleId: string) => {
        navigate(`/admin/articles/${articleId}`);
    };

    const refresh = () => {
        queryArticles(isPublished).then(articles => {
            setArticles(articles)
        });
    };

    const refreshFeaturedArticles = () => {
        queryFeaturedArticles().then(featuredArticles => {
            setFeaturedArticles(featuredArticles);
        });
    };

    useEffect(() => {
        refresh();
        refreshFeaturedArticles();
    }, [isPublished]);

    return (
        <Container disableGutters>
            <Typography variant="h5" mt={2} mb={5}>Articles</Typography>
            <Stack direction="row" spacing={2}>
                <Stack flex={2}>
                    <Stack direction="row" mb={1} height={38}>
                        <Button variant="contained" startIcon={<ArticleRounded />} onClick={handleCreateArticleOnClick}>
                            Create Article
                        </Button>
                        <Box flexGrow={1} />
                        <FormControlLabel
                            value={isPublished}
                            control={<Switch checked={isPublished} onChange={(event) => setIsPublished(event.target.checked) } />}
                            label="Published"
                            labelPlacement="start"
                        />
                    </Stack>
                    <Paper sx={{ overflow: 'hidden' }}>
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell width={76} align="right">Count</TableCell>
                                        <TableCell width={76} align="right">Feature</TableCell>
                                        <TableCell>Title</TableCell>
                                        <TableCell width={220}>Date Published</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {articles.length === 0 && (
                                        <TableRow sx={{
                                            '&:last-child td, &:last-child th': { border: 0 } 
                                        }}>
                                            <TableCell colSpan={4}>
                                                <Typography variant="caption">No articles.</Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {articles.map((article, index) => {
                                        return (
                                            <TableRow
                                                hover
                                                key={article.id}
                                                sx={{
                                                    cursor: 'pointer',
                                                    '&:last-child td, &:last-child th': { border: 0 } 
                                                }}
                                                onClick={() => {
                                                    handleArticleOnClick(article.id)
                                                }}
                                            >
                                                <TableCell align="right">{index + 1}</TableCell>
                                                <TableCell>
                                                    <Checkbox checked={article.featured.isFeatured} />
                                                </TableCell>
                                                <TableCell>{article.title}</TableCell>
                                                <TableCell>{article.published.publishedTime.toFormat("MMMM dd, yyyy hh:mm a")}</TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Stack>
                <Stack flex={1}>
                    <Stack direction="row" alignItems="center" mb={1} height={38}>
                        <Typography>Featured</Typography>
                    </Stack>
                    <Stack spacing={1}>
                        {featuredArticles.map(article => {
                            return (
                                <FeaturedArticleBox key={article.id} article={article} /> 
                            );
                            // if (article.imageUrl.startsWith("https://lottie")) {
                            //     return (
                            //         <FeaturedArticleBox key={article.id} article={article} />
                            //     );
                            // } else {
                            //     return (
                            //         <Card
                            //             key={article.id}
                            //         >
                            //             <CardMedia
                            //                 component="img"
                            //                 image={article.imageUrl}
                            //                 alt={article.title}
                            //             />
                            //         </Card>
                            //     );
                            // }
                        })}
                    </Stack>
                </Stack>
            </Stack>
        </Container>
    )
}